import { createSite } from "api/site";
import { SiteCreateBody } from "api/types/site";
import { notifySimple } from "providers/toast";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import SiteForm, { SiteFormType } from "widgets/forms/sites/site";
import GenericDialog from "./generic";

const AddSiteDialog = (props: {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const { isOpen, onClose, onSuccess } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Function for linking a user
  const doLinkUser = async (formData: SiteFormType) => {
    dispatch(setLoading(true));
    const newSite: SiteCreateBody = {
      name: formData.name,
      reference: formData.reference ? formData.reference : undefined,
    };
    const { status } = await createSite(newSite);
    dispatch(setLoading(false));
    if (status === 200) {
      onSuccess();
      notifySimple(t("notification.site.add.success"), "success");
      onClose();
    } else {
      notifySimple(t("notification.site.add.error"), "error");
    }
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      title={t("dialog.add.site.title")}
      onExit={onClose}
    >
      <SiteForm submit={doLinkUser} onClose={onClose} />
    </GenericDialog>
  );
};

export default AddSiteDialog;
